import Axios from "axios";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
    getTaxCode: (context, data) => {
        return Axios.post((<any>window).App.routes.Profile_GetTaxCode, data);
    },
    getParentTaxCode: (context, data) => {
        return Axios.post((<any>window).App.routes.Profile_GetParentTaxCode, data);
    },
    getParent2TaxCode: (context, data) => {
        return Axios.post((<any>window).App.routes.Profile_GetParent2TaxCode, data);
    },
    getCountries: (context, data) => {
        return Axios.post((<any>window).App.routes.Profile_GetCountries, data);
    },
    getRegions: (context, data) => {
        return Axios.post((<any>window).App.routes.Profile_GetRegions, data);
    },
    getProvinces: (context, data) => {
        return Axios.post((<any>window).App.routes.Profile_GetProvinces, data);
    },
    getLocations: (context, data) => {
        return Axios.post((<any>window).App.routes.Profile_GetLocations, data);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};